import { cn } from '~/lib/utils';

type ScheduledJobTabsProps = {
  tabs: readonly string[];
  activeTabIdx: number;
  onTabChange: (index: number) => void;
  tabIdPrefix: string;
};

/**
 * Index-based underline tabs for scheduled-job settings.
 * Shares visual tokens with ~/components/Tabs (primary active border).
 */
export default function ScheduledJobTabs({
  tabs,
  activeTabIdx,
  onTabChange,
  tabIdPrefix,
}: ScheduledJobTabsProps) {
  return (
    <div className="border-border/70 mt-4 w-full border-b">
      <div role="tablist" aria-label="Scheduled Job Sections" className="flex gap-7 px-6">
        {tabs.map((tab, index) => {
          const isActive = activeTabIdx === index;

          return (
            <button
              type="button"
              role="tab"
              key={tab}
              id={`${tabIdPrefix}-tab-${index}`}
              aria-controls={`${tabIdPrefix}-panel-${index}`}
              aria-selected={isActive}
              className={cn(
                '-mb-px cursor-pointer border-b-2 px-0 pb-2.5 text-[13px] font-medium tracking-[-0.01em] transition-colors',
                'focus-visible:ring-ring/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
                isActive
                  ? 'border-primary text-primary'
                  : 'text-muted-foreground hover:text-foreground/75 border-transparent',
              )}
              onClick={() => onTabChange(index)}
            >
              {tab}
            </button>
          );
        })}
      </div>
    </div>
  );
}
